import { postReq } from '../../api';

export const getTeachersByCourse = (courseId, cb) =>
  postReq('/webapi/student/teacher/get/by-course', { courseId }, '', cb);

export const getAllTeachersPublic = (cb) =>
  postReq('/webapi/student/teacher/get/all', {}, '', cb);
